module.exports = __webpack_public_path__ + "img/adulto48.dd1dd2e5.jpg";